module.exports = __webpack_public_path__ + "static/PRO002_update-5d52da1a05e673ab1afc0bd3ba59e23e.jpg";